var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "history" },
    [
      _c("div", { staticClass: "history-action am-margin-vertical-sm" }, [
        _c("div", { staticClass: "form form-inline" }, [
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("门店名称:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("cc-input", {
                  staticClass: "store-search-wrap",
                  attrs: {
                    styleObj: {
                      maxWidth: "300px",
                      minWidth: "100px",
                      width: "100%"
                    },
                    placeholder: "请输入门店名称",
                    inputlistdata: _vm.searchStoreList,
                    showinputlist: true
                  },
                  on: {
                    input: _vm.handleSearchBrandStore,
                    select: _vm.checkSearchBrandStore,
                    blur: _vm.clearSearchBrandStoreBefore
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "itemText",
                      fn: function(props) {
                        return [
                          !props.item.typeName
                            ? _c("span", [_vm._v(_vm._s(props.item.storeName))])
                            : _c("span", [
                                _vm._v(
                                  "[" +
                                    _vm._s(props.item.typeName) +
                                    "] " +
                                    _vm._s(props.item.storeName)
                                )
                              ])
                        ]
                      }
                    }
                  ]),
                  model: {
                    value: _vm.form.storeName,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "storeName", $$v)
                    },
                    expression: "form.storeName"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("手机号码:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("Input", {
                  attrs: { placeholder: "手机号码", clearable: "" },
                  model: {
                    value: _vm.form.consigneePhone,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "consigneePhone", $$v)
                    },
                    expression: "form.consigneePhone"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [_vm._v("联系人:")]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("Input", {
                  attrs: { placeholder: "联系人", clearable: "" },
                  model: {
                    value: _vm.form.consigneeName,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "consigneeName", $$v)
                    },
                    expression: "form.consigneeName"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("顾客地址:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("Input", {
                  attrs: { placeholder: "顾客地址", clearable: "" },
                  model: {
                    value: _vm.form.consigneeAddress,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "consigneeAddress", $$v)
                    },
                    expression: "form.consigneeAddress"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [_vm._v("订单号:")]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("Input", {
                  attrs: { placeholder: "订单号", clearable: "" },
                  model: {
                    value: _vm.form.orderNo,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "orderNo", $$v)
                    },
                    expression: "form.orderNo"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("外卖平台订单号:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("Input", {
                  attrs: { placeholder: "外卖平台订单号", clearable: "" },
                  model: {
                    value: _vm.form.extOrderId,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "extOrderId", $$v)
                    },
                    expression: "form.extOrderId"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("外卖平台流水号:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("Input", {
                  attrs: { placeholder: "外卖平台流水号", clearable: "" },
                  model: {
                    value: _vm.form.thirdSn,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "thirdSn", $$v)
                    },
                    expression: "form.thirdSn"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("下单渠道:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("cc-select-check", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: {
                    selectOptions: _vm.channelList,
                    allDesc: "全部平台",
                    partDesc: "部分平台"
                  },
                  model: {
                    value: _vm.form.fromTypeList,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "fromTypeList", $$v)
                    },
                    expression: "form.fromTypeList"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("订单状态:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("cc-select", {
                  staticStyle: { "vertical-align": "middle" },
                  attrs: { options: _vm.orderStatusList },
                  model: {
                    value: _vm.form.status,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "status", $$v)
                    },
                    expression: "form.status"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c("div", { staticClass: "form-item-label" }, [
              _vm._v("下单时间:")
            ]),
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c("cc-calendar", {
                  staticClass: "dateStart am-inline-block",
                  attrs: { placeholder: "下单时间从", backward: true },
                  model: {
                    value: _vm.form.startTime,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "startTime", $$v)
                    },
                    expression: "form.startTime"
                  }
                }),
                _c(
                  "div",
                  {
                    staticClass: "am-inline-block",
                    staticStyle: { padding: "0 5px" }
                  },
                  [_vm._v("-")]
                ),
                _c("cc-calendar", {
                  staticClass: "dateStart am-inline-block",
                  attrs: { placeholder: "下单时间到", backward: true },
                  model: {
                    value: _vm.form.endTime,
                    callback: function($$v) {
                      _vm.$set(_vm.form, "endTime", $$v)
                    },
                    expression: "form.endTime"
                  }
                })
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c(
                  "Button",
                  {
                    attrs: { loading: _vm.queryLoading },
                    nativeOn: {
                      click: function($event) {
                        return _vm.handleQuery.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("\n            查询\n          ")]
                )
              ],
              1
            )
          ]),
          _c("div", { staticClass: "form-item" }, [
            _c(
              "div",
              { staticClass: "form-item-content" },
              [
                _c(
                  "Button",
                  {
                    staticClass: "am-btn-cancel",
                    nativeOn: {
                      click: function($event) {
                        return _vm.handleReset.apply(null, arguments)
                      }
                    }
                  },
                  [_vm._v("重置")]
                )
              ],
              1
            )
          ])
        ])
      ]),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.list.length > 0,
              expression: "list.length>0"
            }
          ],
          staticClass: "history-content am-g am-g-collapse"
        },
        [
          _c("div", { staticClass: "am-u-sm-4" }, [
            _c("div", { staticClass: "order-left" }, [
              _c(
                "div",
                { staticClass: "order-list" },
                _vm._l(_vm.list, function(item, index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "order-item",
                      class: { active: _vm.orderObj.orderId === item.orderId },
                      on: {
                        click: function($event) {
                          return _vm.checkOrder(item.orderId)
                        }
                      }
                    },
                    [
                      _c("div", { staticClass: "am-g am-g-collapse" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "am-u-sm-3 order-name am-text-truncate",
                            attrs: { title: item.consigneeName }
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.consigneeName) +
                                "\n              "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          { staticClass: "am-u-sm-4 am-text-truncate" },
                          [
                            item.countryCode
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      "margin-right": "10px",
                                      "border-right": "1px solid #ccc",
                                      "padding-right": "10px"
                                    }
                                  },
                                  [_vm._v(_vm._s(item.countryCode))]
                                )
                              : _vm._e(),
                            _vm._v(
                              "\n                " +
                                _vm._s(item.consigneePhone) +
                                "\n              "
                            )
                          ]
                        ),
                        _c(
                          "div",
                          {
                            staticClass:
                              "am-u-sm-5 am-text-truncate am-text-right"
                          },
                          [
                            _vm._v(
                              "\n                " +
                                _vm._s(item.createTime) +
                                "\n              "
                            )
                          ]
                        )
                      ]),
                      _c("div", { staticClass: "order-address" }, [
                        _c("span", [_vm._v("地址：")]),
                        _c("span", [_vm._v(_vm._s(item.consigneeAddress))])
                      ]),
                      _c("div", { staticClass: "order-price" }, [
                        _c("span", [
                          _vm._v("\n              订单金额：\n            ")
                        ]),
                        _c("span", [
                          _vm._v(_vm._s(_vm.currency) + _vm._s(item.totalPrice))
                        ])
                      ])
                    ]
                  )
                }),
                0
              ),
              _c("div", { staticClass: "paging am-padding-sm" }, [
                _c("div", { staticClass: "paging-contain" }, [
                  _c("div", { staticClass: "paging-item" }, [
                    _vm._v(
                      "\n              第" +
                        _vm._s(_vm.form.pageNow) +
                        "页\n            "
                    )
                  ]),
                  _c(
                    "div",
                    { staticClass: "paging-item" },
                    [
                      _c(
                        "Button",
                        {
                          attrs: { disabled: _vm.form.pageNow <= 1 },
                          nativeOn: {
                            click: function($event) {
                              return _vm.changePaging(_vm.form.pageNow - 1)
                            }
                          }
                        },
                        [_vm._v("上一页")]
                      )
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "paging-item" },
                    [
                      _c(
                        "Button",
                        {
                          attrs: {
                            disabled: _vm.form.pageNow >= _vm.form.pageTotal
                          },
                          nativeOn: {
                            click: function($event) {
                              return _vm.changePaging(_vm.form.pageNow + 1)
                            }
                          }
                        },
                        [_vm._v("下一页\n              ")]
                      )
                    ],
                    1
                  ),
                  _c("div", { staticClass: "paging-item" }, [
                    _vm._v(
                      "\n              共" +
                        _vm._s(_vm.form.pageTotal) +
                        "页\n            "
                    )
                  ])
                ])
              ])
            ])
          ]),
          _c("div", { staticClass: "am-u-sm-8" }, [
            _c(
              "div",
              {
                staticClass: "order-details am-padding-horizontal-sm am-scroll"
              },
              [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.order.length > 0,
                        expression: "order.length>0"
                      }
                    ],
                    staticClass: "am-g"
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "order-action am-text-right am-margin-vertical-sm"
                      },
                      [
                        _c(
                          "Button",
                          {
                            staticClass: "am-margin-right-sm",
                            attrs: {
                              disabled:
                                _vm.orderObj.dealOrderType === 2 ||
                                _vm.orderObj.status === -1
                            },
                            nativeOn: {
                              click: function($event) {
                                return _vm.showCancelOrder.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v("取消订单\n            ")]
                        ),
                        _c(
                          "Button",
                          {
                            staticClass: "am-margin-right-sm",
                            nativeOn: {
                              click: function($event) {
                                return _vm.checkToUpdateOrder.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v("修改订单")]
                        ),
                        _c(
                          "Button",
                          {
                            staticClass: "am-margin-right-sm",
                            nativeOn: {
                              click: function($event) {
                                return _vm.showComplaint.apply(null, arguments)
                              }
                            }
                          },
                          [_vm._v("催单投诉")]
                        ),
                        _c(
                          "Button",
                          {
                            staticClass: "am-margin-right-sm",
                            attrs: { loading: _vm.AdjustLoading },
                            nativeOn: {
                              click: function($event) {
                                return _vm.showAdjustStoreBefore.apply(
                                  null,
                                  arguments
                                )
                              }
                            }
                          },
                          [_vm._v("门店调整\n            ")]
                        )
                      ],
                      1
                    ),
                    _vm._l(_vm.order, function(item, index) {
                      return _c(
                        "div",
                        {
                          key: index,
                          staticClass: "am-g am-g-collapse order-base-info"
                        },
                        [
                          item.order
                            ? [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "order-info-item am-text-center"
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "order-info-total" },
                                      [
                                        _c("span", [_vm._v("订单金额")]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.currency) +
                                              _vm._s(item.order.totalPrice)
                                          )
                                        ]),
                                        _c("span", [_vm._v("订单份数")]),
                                        _c("span", [
                                          _vm._v(_vm._s(item.productSum) + "份")
                                        ]),
                                        _c("span", [_vm._v("外送费")]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.currency) +
                                              _vm._s(item.order.deliveryFee)
                                          )
                                        ]),
                                        _c("span", [_vm._v("餐盒费")]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.currency) +
                                              _vm._s(item.order.mealFee)
                                          )
                                        ]),
                                        _c("span", [_vm._v("优惠金额合计")]),
                                        _c("span", [
                                          _vm._v(
                                            _vm._s(_vm.currency) +
                                              _vm._s(item.order.productPrePrice)
                                          )
                                        ])
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "am-g am-margin-vertical-sm" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("品牌名称：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.brandName)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-8 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("门店名称：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.storeName)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("订单号：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.orderNo)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("系统流水号：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.sn
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("第三方流水号：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.thirdSn
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("第三方订单号：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.extOrderId
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-8 order-info-item am-u-end"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("下单渠道：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.order.fromTypeName
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-8 order-info-item am-u-end"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("实际下单渠道：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.actualOrderChannelName
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("取餐类型：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.order.orderTypeName
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("下单时间：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.createTime)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("预送达时间：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.sendTime)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("订餐人：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.order.consigneeName
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("联系电话：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                item.order
                                                  .consigneePhoneCountryCode
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          "margin-right":
                                                            "10px",
                                                          "border-right":
                                                            "1px solid #ccc",
                                                          "padding-right":
                                                            "10px"
                                                        }
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(
                                                            item.order
                                                              .consigneePhoneCountryCode
                                                          )
                                                        )
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm._v(
                                                  _vm._s(
                                                    item.order.consigneePhone
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    item.order.vipPhone
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "am-u-sm-4 order-info-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-item" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-item-label"
                                                  },
                                                  [_vm._v("会员电话：")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-item-content"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.order.vipPhone
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("就餐人数：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.peopleNum)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("送餐地址：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    item.order.consigneeAddress
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("下单方式：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.fromTypeNote
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _vm.isColaCupConversionListeningSet
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "am-u-sm-4 order-info-item"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "form-item" },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-item-label"
                                                  },
                                                  [_vm._v("杯听情况：")]
                                                ),
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass:
                                                      "form-item-content"
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm._f(
                                                          "cupListeningSetType"
                                                        )(
                                                          item.order
                                                            .cupListeningSet
                                                        )
                                                      )
                                                    )
                                                  ]
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-12 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("客户备注：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.userNote
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-12 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("商家备注：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order
                                                        .storeNoteContent
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("是否已支付：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isBoolen")(
                                                      item.order.isPayed
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("支付方式：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.payTypeName)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("支付信息：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm._f("offlinePays")(
                                                        item.order
                                                          .paymentDetails
                                                      )
                                                    )
                                                  )
                                                ])
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("是否开发票：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isBoolen")(
                                                      item.order.isInvoice
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("发票类型：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.invoiceTypeName
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("发票抬头：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.invoiceDesc
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-12 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("发票税号：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.order.taxNo
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-12 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("本单优惠：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._l(
                                                  item.order.orderPreferentials,
                                                  function(item, index) {
                                                    return _c(
                                                      "div",
                                                      { key: index },
                                                      [
                                                        _vm._v(
                                                          "\n                        " +
                                                            _vm._s(
                                                              _vm._f(
                                                                "preferentialType"
                                                              )(
                                                                item.type,
                                                                item.childType
                                                              )
                                                            ) +
                                                            _vm._s(
                                                              item.content
                                                            ) +
                                                            _vm._s(
                                                              _vm.currency
                                                            ) +
                                                            " " +
                                                            _vm._s(item.price) +
                                                            "\n                      "
                                                        )
                                                      ]
                                                    )
                                                  }
                                                ),
                                                item.order.orderPreferentials
                                                  .length === 0
                                                  ? _c("div", [_vm._v("无")])
                                                  : _vm._e()
                                              ],
                                              2
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("配送公司：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(item.order.driverName)
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("骑手姓名：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      " +
                                                    _vm._s(
                                                      _vm._f("getKeys")(
                                                        item.order.orderDrivers,
                                                        "name"
                                                      )
                                                    ) +
                                                    "\n                    "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("骑手电话：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("getKeys")(
                                                      item.order.orderDrivers,
                                                      "phone"
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "am-u-sm-4 order-info-item"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("第三方物流单号：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isEmpty")(
                                                      item.logisticsNo
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    ),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "am-u-sm-4 order-info-item am-u-end"
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "form-item" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-label"
                                              },
                                              [_vm._v("是否平台配送：")]
                                            ),
                                            _c(
                                              "div",
                                              {
                                                staticClass: "form-item-content"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm._f("isBoolen")(
                                                      item.order
                                                        .isThirdDistribute
                                                    )
                                                  )
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ]
                                    )
                                  ]
                                ),
                                _c(
                                  "div",
                                  { staticClass: "order-tabs am-cf" },
                                  [
                                    _c(
                                      "Tabs",
                                      [
                                        _c(
                                          "TabPane",
                                          { attrs: { label: "产品信息" } },
                                          _vm._l(
                                            item.order.orderProducts,
                                            function(item, index) {
                                              return _c(
                                                "div",
                                                {
                                                  key: index,
                                                  staticClass:
                                                    "am-margin-bottom-sm"
                                                },
                                                [
                                                  _c(
                                                    "table",
                                                    {
                                                      staticClass: "order-table"
                                                    },
                                                    [
                                                      _c(
                                                        "thead",
                                                        {
                                                          staticClass:
                                                            "order-table-head"
                                                        },
                                                        [
                                                          _c("tr", [
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "w200"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "产品名称"
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "w300"
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "特殊要求"
                                                                )
                                                              ]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "w90"
                                                              },
                                                              [_vm._v("分袋")]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "w90"
                                                              },
                                                              [_vm._v("单价")]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "w90"
                                                              },
                                                              [_vm._v("数量")]
                                                            ),
                                                            _c(
                                                              "th",
                                                              {
                                                                staticClass:
                                                                  "w90"
                                                              },
                                                              [_vm._v("合计")]
                                                            )
                                                          ])
                                                        ]
                                                      ),
                                                      _c(
                                                        "tbody",
                                                        {
                                                          staticClass:
                                                            "order-table-body"
                                                        },
                                                        [
                                                          _c("tr", [
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.products
                                                                    ? "套餐"
                                                                    : "单品"
                                                                ) +
                                                                  "：" +
                                                                  _vm._s(
                                                                    item.name
                                                                  )
                                                              )
                                                            ]),
                                                            _c(
                                                              "td",
                                                              _vm._l(
                                                                item.listRequirements,
                                                                function(
                                                                  item,
                                                                  index
                                                                ) {
                                                                  return _c(
                                                                    "span",
                                                                    {
                                                                      key: index
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "span",
                                                                        [
                                                                          _vm._v(
                                                                            _vm._s(
                                                                              _vm._f(
                                                                                "formatAdditional"
                                                                              )(
                                                                                item.propertys
                                                                              )
                                                                            )
                                                                          )
                                                                        ]
                                                                      )
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                            _c("td"),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.price
                                                                )
                                                              )
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(item.num)
                                                              )
                                                            ]),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.realTimeTotalPrice
                                                                )
                                                              )
                                                            ])
                                                          ])
                                                        ]
                                                      )
                                                    ]
                                                  ),
                                                  item.products &&
                                                  item.products.length > 0
                                                    ? [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "am-margin-top-sm"
                                                          },
                                                          [
                                                            _c(
                                                              "table",
                                                              {
                                                                staticClass:
                                                                  "order-table order-combo"
                                                              },
                                                              [
                                                                _c(
                                                                  "tbody",
                                                                  {
                                                                    staticClass:
                                                                      "order-table-body"
                                                                  },
                                                                  [
                                                                    _c("tr", [
                                                                      _c(
                                                                        "td",
                                                                        {
                                                                          staticClass:
                                                                            "w200 am-text-center"
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "套餐内容"
                                                                          )
                                                                        ]
                                                                      ),
                                                                      _c("td", [
                                                                        _c(
                                                                          "table",
                                                                          {
                                                                            staticClass:
                                                                              "order-table order-table-striped"
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "thead",
                                                                              {
                                                                                staticClass:
                                                                                  "order-table-head"
                                                                              },
                                                                              [
                                                                                _c(
                                                                                  "tr",
                                                                                  [
                                                                                    _c(
                                                                                      "th",
                                                                                      {
                                                                                        staticClass:
                                                                                          "w200"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                      名称\n                                    "
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "th",
                                                                                      {
                                                                                        staticClass:
                                                                                          "w90"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                      数量\n                                    "
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "th",
                                                                                      {
                                                                                        staticClass:
                                                                                          "w90"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                      价钱\n                                    "
                                                                                        )
                                                                                      ]
                                                                                    ),
                                                                                    _c(
                                                                                      "th",
                                                                                      {
                                                                                        staticClass:
                                                                                          "w300"
                                                                                      },
                                                                                      [
                                                                                        _vm._v(
                                                                                          "\n                                      特殊要求\n                                    "
                                                                                        )
                                                                                      ]
                                                                                    )
                                                                                  ]
                                                                                )
                                                                              ]
                                                                            ),
                                                                            _c(
                                                                              "tbody",
                                                                              {
                                                                                staticClass:
                                                                                  "order-table-body"
                                                                              },
                                                                              _vm._l(
                                                                                item.products,
                                                                                function(
                                                                                  item,
                                                                                  index
                                                                                ) {
                                                                                  return _c(
                                                                                    "tr",
                                                                                    {
                                                                                      key: index
                                                                                    },
                                                                                    [
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.name
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.num
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        [
                                                                                          _vm._v(
                                                                                            _vm._s(
                                                                                              item.totalPrice
                                                                                            )
                                                                                          )
                                                                                        ]
                                                                                      ),
                                                                                      _c(
                                                                                        "td",
                                                                                        _vm._l(
                                                                                          item.listRequirements,
                                                                                          function(
                                                                                            item,
                                                                                            index
                                                                                          ) {
                                                                                            return _c(
                                                                                              "span",
                                                                                              {
                                                                                                key: index
                                                                                              },
                                                                                              [
                                                                                                _c(
                                                                                                  "span",
                                                                                                  [
                                                                                                    _vm._v(
                                                                                                      _vm._s(
                                                                                                        _vm._f(
                                                                                                          "formatAdditional"
                                                                                                        )(
                                                                                                          item.propertys
                                                                                                        )
                                                                                                      )
                                                                                                    )
                                                                                                  ]
                                                                                                )
                                                                                              ]
                                                                                            )
                                                                                          }
                                                                                        ),
                                                                                        0
                                                                                      )
                                                                                    ]
                                                                                  )
                                                                                }
                                                                              ),
                                                                              0
                                                                            )
                                                                          ]
                                                                        )
                                                                      ])
                                                                    ]),
                                                                    _c("tr")
                                                                  ]
                                                                )
                                                              ]
                                                            )
                                                          ]
                                                        )
                                                      ]
                                                    : _vm._e()
                                                ],
                                                2
                                              )
                                            }
                                          ),
                                          0
                                        ),
                                        _c(
                                          "TabPane",
                                          { attrs: { label: "订单记录" } },
                                          [
                                            _c(
                                              "table",
                                              { staticClass: "order-table" },
                                              [
                                                _c(
                                                  "thead",
                                                  {
                                                    staticClass:
                                                      "order-table-head"
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v("时间")
                                                      ]),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("订单状态")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("配送状态")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("操作人")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "am-text-not-line"
                                                        },
                                                        [_vm._v("状态持续时间")]
                                                      ),
                                                      _c("th", [_vm._v("备注")])
                                                    ])
                                                  ]
                                                ),
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "order-table-body"
                                                  },
                                                  [
                                                    item.infoRecords
                                                      ? _vm._l(
                                                          item.infoRecords,
                                                          function(
                                                            item,
                                                            index
                                                          ) {
                                                            return _c(
                                                              "tr",
                                                              { key: index },
                                                              [
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "am-text-not-line"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.createTime
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "am-text-not-line"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.statusName
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "am-text-not-line"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm._f(
                                                                          "driverStatus"
                                                                        )(
                                                                          item.deliveryStatus
                                                                        )
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "am-text-not-line"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.operaterName
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "td",
                                                                  {
                                                                    staticClass:
                                                                      "am-text-not-line"
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        item.durTime
                                                                      )
                                                                    )
                                                                  ]
                                                                ),
                                                                _c("td", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      item.sysNote
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          }
                                                        )
                                                      : _vm._e()
                                                  ],
                                                  2
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "TabPane",
                                          { attrs: { label: "催单投诉" } },
                                          [
                                            _c(
                                              "table",
                                              { staticClass: "order-table" },
                                              [
                                                _c(
                                                  "thead",
                                                  {
                                                    staticClass:
                                                      "order-table-head"
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v("反馈时间")
                                                      ]),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("反馈类型")]
                                                      ),
                                                      _c("th", [
                                                        _vm._v("反馈内容")
                                                      ]),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("操作人")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w300" },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "am-g"
                                                            },
                                                            [
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "am-u-sm-4"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              回复内容\n                            "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "am-u-sm-5"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              回复时间\n                            "
                                                                  )
                                                                ]
                                                              ),
                                                              _c(
                                                                "div",
                                                                {
                                                                  staticClass:
                                                                    "am-u-sm-3"
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "\n                              回复人\n                            "
                                                                  )
                                                                ]
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "order-table-body"
                                                  },
                                                  _vm._l(
                                                    item.orderWarningRecords,
                                                    function(item, index) {
                                                      return _c(
                                                        "tr",
                                                        { key: index },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "am-text-not-line"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.createTime
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "operationType"
                                                                )(
                                                                  item.operationType
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(item.text)
                                                            )
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.operatorName
                                                              )
                                                            )
                                                          ]),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "w320"
                                                            },
                                                            _vm._l(
                                                              item.replyList,
                                                              function(
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: index,
                                                                    staticClass:
                                                                      "am-g am-word-wrap am-margin-bottom-sm"
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "am-u-sm-4"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "am-padding-right-sm"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.replyText
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "am-u-sm-5"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "am-padding-right-sm"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.createTime
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "div",
                                                                      {
                                                                        staticClass:
                                                                          "am-u-sm-3"
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "div",
                                                                          {
                                                                            staticClass:
                                                                              "am-padding-right-sm"
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                item.operaterName
                                                                              )
                                                                            )
                                                                          ]
                                                                        )
                                                                      ]
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                          _c("td"),
                                                          _c("td")
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "TabPane",
                                          { attrs: { label: "退款记录" } },
                                          [
                                            _c(
                                              "table",
                                              { staticClass: "order-table" },
                                              [
                                                _c(
                                                  "thead",
                                                  {
                                                    staticClass:
                                                      "order-table-head"
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("退款状态")]
                                                      ),
                                                      _c("th", [
                                                        _vm._v("原因")
                                                      ]),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("退款类型")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("退款餐品")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("操作人")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w200" },
                                                        [_vm._v("处理时间")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        { staticClass: "w90" },
                                                        [_vm._v("备注")]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "order-table-body"
                                                  },
                                                  _vm._l(
                                                    item.orderApplyReCords,
                                                    function(item, index) {
                                                      return _c(
                                                        "tr",
                                                        { key: index },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "am-text-not-line"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.refundStatusName
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.reason
                                                              )
                                                            )
                                                          ]),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "am-text-not-line"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm._f(
                                                                    "refundType"
                                                                  )(
                                                                    item.refundType
                                                                  )
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c(
                                                            "td",
                                                            _vm._l(
                                                              item.orderRefundProducts,
                                                              function(
                                                                item,
                                                                index
                                                              ) {
                                                                return _c(
                                                                  "div",
                                                                  {
                                                                    key: index
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                            " +
                                                                        _vm._s(
                                                                          item.pname
                                                                        ) +
                                                                        " - " +
                                                                        _vm._s(
                                                                          item.num
                                                                        ) +
                                                                        "份\n                          "
                                                                    )
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                            0
                                                          ),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.operatorName
                                                              )
                                                            )
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.createTime
                                                              )
                                                            )
                                                          ]),
                                                          _c("td")
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "TabPane",
                                          { attrs: { label: "修改记录" } },
                                          [
                                            _c(
                                              "table",
                                              { staticClass: "order-table" },
                                              [
                                                _c(
                                                  "thead",
                                                  {
                                                    staticClass:
                                                      "order-table-head"
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "am-text-not-line"
                                                        },
                                                        [_vm._v("操作时间")]
                                                      ),
                                                      _c("th", [
                                                        _vm._v("修改内容")
                                                      ]),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "am-text-not-line"
                                                        },
                                                        [_vm._v("操作人")]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "order-table-body"
                                                  },
                                                  _vm._l(
                                                    item.orderChanges,
                                                    function(item, index) {
                                                      return _c(
                                                        "tr",
                                                        { key: index },
                                                        [
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "am-text-not-line"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.createTime
                                                                )
                                                              )
                                                            ]
                                                          ),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.changeDetails
                                                              )
                                                            )
                                                          ]),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "am-text-not-line"
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.operaterName
                                                                )
                                                              )
                                                            ]
                                                          )
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ]
                                        ),
                                        _c(
                                          "TabPane",
                                          { attrs: { label: "支付详情" } },
                                          [
                                            _c(
                                              "table",
                                              { staticClass: "order-table" },
                                              [
                                                _c(
                                                  "thead",
                                                  {
                                                    staticClass:
                                                      "order-table-head"
                                                  },
                                                  [
                                                    _c("tr", [
                                                      _c("th", [
                                                        _vm._v("支付详情")
                                                      ]),
                                                      _c("th", [
                                                        _vm._v("备注")
                                                      ]),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "am-text-not-line"
                                                        },
                                                        [_vm._v("操作人")]
                                                      ),
                                                      _c(
                                                        "th",
                                                        {
                                                          staticClass:
                                                            "am-text-not-line"
                                                        },
                                                        [_vm._v("时间")]
                                                      )
                                                    ])
                                                  ]
                                                ),
                                                _c(
                                                  "tbody",
                                                  {
                                                    staticClass:
                                                      "order-table-body"
                                                  },
                                                  _vm._l(
                                                    item.orderChangePayDetailList,
                                                    function(item, index) {
                                                      return _c(
                                                        "tr",
                                                        { key: index },
                                                        [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "offlinePays"
                                                                )(
                                                                  item.paymentDetailList
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "isEmpty"
                                                                )(item.remark)
                                                              )
                                                            )
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm._f(
                                                                  "isEmpty"
                                                                )(
                                                                  item.handlePerson
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                item.changeTime
                                                              )
                                                            )
                                                          ])
                                                        ]
                                                      )
                                                    }
                                                  ),
                                                  0
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ]
                            : _vm._e()
                        ],
                        2
                      )
                    })
                  ],
                  2
                ),
                _c("cc-loading-box", {
                  staticClass: "loading-box",
                  attrs: { isLoading: _vm.isOrderLoading }
                })
              ],
              1
            )
          ])
        ]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.list.length === 0 && !_vm.queryLoading,
              expression: "list.length === 0 && !queryLoading"
            }
          ],
          staticClass: "order-empty am-padding-vertical-xl"
        },
        [_vm._v("\n    查无数据\n  ")]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          model: {
            value: _vm.complaint.visible,
            callback: function($$v) {
              _vm.$set(_vm.complaint, "visible", $$v)
            },
            expression: "complaint.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("催单投诉")
          ]),
          _c(
            "div",
            { staticClass: "form complaint" },
            [
              _c("div", { staticClass: "form-item" }, [
                _c("div", { staticClass: "form-item-label" }, [
                  _vm._v("\n          类型：\n        ")
                ]),
                _c(
                  "div",
                  { staticClass: "form-item-content" },
                  [
                    _c(
                      "RadioGroup",
                      {
                        model: {
                          value: _vm.complaint.checkValue,
                          callback: function($$v) {
                            _vm.$set(_vm.complaint, "checkValue", $$v)
                          },
                          expression: "complaint.checkValue"
                        }
                      },
                      _vm._l(_vm.complaint.type, function(item, index) {
                        return _c("Radio", {
                          key: index,
                          attrs: { label: item.id, custom: "" },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var currentValue = ref.currentValue
                                  return _c(
                                    "div",
                                    {
                                      staticClass: "am-button-custom",
                                      class: { active: currentValue }
                                    },
                                    [
                                      _vm._v(
                                        "\n                " +
                                          _vm._s(item.name) +
                                          "\n              "
                                      )
                                    ]
                                  )
                                }
                              }
                            ],
                            null,
                            true
                          )
                        })
                      }),
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm.complaint.checkValue === 2
                ? [
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-item-label" }, [
                        _vm._v("\n            催单时间：\n          ")
                      ]),
                      _c(
                        "div",
                        { staticClass: "form-item-content" },
                        [
                          _c("cc-select", {
                            staticStyle: { "vertical-align": "middle" },
                            attrs: {
                              options: _vm.complaint.callOrderTypeList,
                              placeholder: "请选择催单时间",
                              valueKey: "id",
                              labelKey: "name"
                            },
                            model: {
                              value: _vm.complaint.reminderValue,
                              callback: function($$v) {
                                _vm.$set(_vm.complaint, "reminderValue", $$v)
                              },
                              expression: "complaint.reminderValue"
                            }
                          })
                        ],
                        1
                      )
                    ]),
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-item-label" }, [
                        _vm._v("\n            备注：\n          ")
                      ]),
                      _c("div", { staticClass: "form-item-content" }, [
                        _c("div", { staticClass: "am-textarea-wrap" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.complaint.reminderText,
                                expression: "complaint.reminderText"
                              }
                            ],
                            staticClass: "am-textarea",
                            attrs: { maxlength: "150" },
                            domProps: { value: _vm.complaint.reminderText },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.complaint,
                                  "reminderText",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _c("div", { staticClass: "form-item-content" }, [
                        _c(
                          "span",
                          {
                            staticClass: "am-padding-left-sm",
                            staticStyle: { color: "#aaa" }
                          },
                          [
                            _vm._v(
                              "\n               *必填，最多还可以输入" +
                                _vm._s(
                                  150 - _vm.complaint.reminderText.length
                                ) +
                                "字\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                : _vm.complaint.checkValue === 3
                ? [
                    _vm.complaint.complaintBigReason.length
                      ? _c("div", { staticClass: "form-item" }, [
                          _c("div", { staticClass: "form-item-label" }, [
                            _vm._v("\n            投诉类型：\n          ")
                          ]),
                          _c(
                            "div",
                            { staticClass: "form-item-content" },
                            [
                              _c("cc-select", {
                                staticStyle: { "vertical-align": "middle" },
                                attrs: {
                                  options: _vm.complaint.complaintBigReason,
                                  width: 160,
                                  valueKey: "id",
                                  labelKey: "name"
                                },
                                on: { change: _vm.checkComplaintBig },
                                model: {
                                  value: _vm.complaint.complaintBigValue,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.complaint,
                                      "complaintBigValue",
                                      $$v
                                    )
                                  },
                                  expression: "complaint.complaintBigValue"
                                }
                              })
                            ],
                            1
                          ),
                          _vm.complaint.complaintSmallReason.length
                            ? _c(
                                "div",
                                {
                                  staticClass:
                                    "form-item-content am-padding-left-sm"
                                },
                                [
                                  _c("cc-select", {
                                    staticStyle: { "vertical-align": "middle" },
                                    attrs: {
                                      options:
                                        _vm.complaint.complaintSmallReason,
                                      width: 160,
                                      valueKey: "id",
                                      labelKey: "name"
                                    },
                                    model: {
                                      value: _vm.complaint.complaintSmallValue,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.complaint,
                                          "complaintSmallValue",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "complaint.complaintSmallValue"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-item-label" }, [
                        _vm._v("\n            备注：\n          ")
                      ]),
                      _c("div", { staticClass: "form-item-content" }, [
                        _c("div", { staticClass: "am-textarea-wrap" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.complaint.complaintText,
                                expression: "complaint.complaintText"
                              }
                            ],
                            staticClass: "am-textarea",
                            attrs: { maxlength: "150" },
                            domProps: { value: _vm.complaint.complaintText },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.complaint,
                                  "complaintText",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _c("div", { staticClass: "form-item-content" }, [
                        _c(
                          "span",
                          {
                            staticClass: "am-padding-left-sm",
                            staticStyle: { color: "#aaa" }
                          },
                          [
                            _vm._v(
                              "\n                *必填，最多还可以输入" +
                                _vm._s(
                                  150 - _vm.complaint.complaintText.length
                                ) +
                                "字\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
                : [
                    _c("div", { staticClass: "form-item" }, [
                      _c("div", { staticClass: "form-item-label" }, [
                        _vm._v("\n            备注：\n          ")
                      ]),
                      _c("div", { staticClass: "form-item-content" }, [
                        _c("div", { staticClass: "am-textarea-wrap" }, [
                          _c("textarea", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.complaint.remindText,
                                expression: "complaint.remindText"
                              }
                            ],
                            staticClass: "am-textarea",
                            attrs: { maxlength: "150" },
                            domProps: { value: _vm.complaint.remindText },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(
                                  _vm.complaint,
                                  "remindText",
                                  $event.target.value
                                )
                              }
                            }
                          })
                        ])
                      ]),
                      _c("div", { staticClass: "form-item-content" }, [
                        _c(
                          "span",
                          {
                            staticClass: "am-padding-left-sm",
                            staticStyle: { color: "#aaa" }
                          },
                          [
                            _vm._v(
                              "\n               *必填，最多还可以输入" +
                                _vm._s(
                                  150 - _vm.complaint.complaintText.length
                                ) +
                                "字\n            "
                            )
                          ]
                        )
                      ])
                    ])
                  ]
            ],
            2
          ),
          _c(
            "div",
            {
              staticClass: "am-text-right",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  attrs: { disabled: !_vm.isComplaintDisabled },
                  nativeOn: {
                    click: function($event) {
                      return _vm.addOrderWarning.apply(null, arguments)
                    }
                  }
                },
                [_vm._v("确认")]
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-cancel",
                  nativeOn: {
                    click: function($event) {
                      _vm.complaint.visible = false
                    }
                  }
                },
                [_vm._v("放弃")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          model: {
            value: _vm.orderCancel.visible,
            callback: function($$v) {
              _vm.$set(_vm.orderCancel, "visible", $$v)
            },
            expression: "orderCancel.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("提示")
          ]),
          _c("div", { staticClass: "form order-cancel-form" }, [
            _c("div", { staticClass: "form-item" }, [
              _c("div", { staticClass: "form-item-label" }, [
                _vm._v("请选择取消原因")
              ]),
              _c(
                "div",
                { staticClass: "form-item-content" },
                [
                  _c("cc-select", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      options: _vm.orderCancel.reasonList,
                      valueKey: "index",
                      labelKey: "name"
                    },
                    on: { change: _vm.checkBigCancelReasons },
                    model: {
                      value: _vm.orderCancel.reasonValue,
                      callback: function($$v) {
                        _vm.$set(_vm.orderCancel, "reasonValue", $$v)
                      },
                      expression: "orderCancel.reasonValue"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "form-item" }, [
              _c("div", { staticClass: "form-item-label" }, [
                _vm._v("二级取消原因")
              ]),
              _c(
                "div",
                { staticClass: "form-item-content" },
                [
                  _c("cc-select", {
                    staticStyle: { "vertical-align": "middle" },
                    attrs: {
                      options: _vm.orderCancel.childReasonList,
                      valueKey: "index",
                      labelKey: "name"
                    },
                    model: {
                      value: _vm.orderCancel.childReasonValue,
                      callback: function($$v) {
                        _vm.$set(_vm.orderCancel, "childReasonValue", $$v)
                      },
                      expression: "orderCancel.childReasonValue"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "form-item" }, [
              _c("div", { staticClass: "form-item-label" }, [
                _vm._v("取消备注")
              ]),
              _c("div", { staticClass: "form-item-content" }, [
                _c("div", { staticClass: "am-textarea-wrap" }, [
                  _c("textarea", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.orderCancel.tips,
                        expression: "orderCancel.tips"
                      }
                    ],
                    staticClass: "am-textarea",
                    attrs: { maxlength: "150" },
                    domProps: { value: _vm.orderCancel.tips },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.orderCancel, "tips", $event.target.value)
                      }
                    }
                  })
                ])
              ]),
              _c("div", { staticClass: "form-item-content" }, [
                _c(
                  "span",
                  {
                    staticClass: "am-padding-left-sm",
                    staticStyle: { color: "#aaa" }
                  },
                  [
                    _vm._v(
                      "\n               *必填，最多还可以输入" +
                        _vm._s(150 - _vm.orderCancel.tips.length) +
                        "字\n            "
                    )
                  ]
                )
              ])
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "am-text-right",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  attrs: {
                    disabled:
                      !_vm.orderCancel.reasonValue ||
                      !_vm.orderCancel.childReasonValue ||
                      !_vm.orderCancel.tips
                  },
                  on: { click: _vm.changeOrderStatus }
                },
                [_vm._v("保存\n      ")]
              ),
              _c(
                "Button",
                {
                  staticClass: "am-btn-cancel",
                  nativeOn: {
                    click: function($event) {
                      _vm.orderCancel.visible = false
                    }
                  }
                },
                [_vm._v("放弃")]
              )
            ],
            1
          )
        ]
      ),
      _c(
        "Modal",
        {
          attrs: { width: "850px" },
          model: {
            value: _vm.adjustStore.visible,
            callback: function($$v) {
              _vm.$set(_vm.adjustStore, "visible", $$v)
            },
            expression: "adjustStore.visible"
          }
        },
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _vm._v("选择门店")
          ]),
          _c("div", { staticClass: "am-g" }, [
            _c("div", { staticClass: "form form-inline" }, [
              _c("div", { staticClass: "form-item" }, [
                _c("div", { staticClass: "form-item-label" }, [
                  _vm._v("门店名称")
                ]),
                _c(
                  "div",
                  { staticClass: "form-item-content" },
                  [
                    _c("cc-input", {
                      staticClass: "store-search-wrap",
                      attrs: {
                        styleObj: {
                          maxWidth: "300px",
                          minWidth: "100px",
                          width: "100%"
                        },
                        placeholder: "请输入门店名称",
                        inputlistdata: _vm.adjustStore.searchStoreList,
                        showinputlist: true
                      },
                      on: {
                        input: _vm.handleSearchStore,
                        select: _vm.checkSearchStore,
                        blur: _vm.clearSearchStore
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "itemText",
                          fn: function(props) {
                            return [
                              !props.item.typeName
                                ? _c("span", [
                                    _vm._v(_vm._s(props.item.storeName))
                                  ])
                                : _c("span", [
                                    _vm._v(
                                      "[" +
                                        _vm._s(props.item.typeName) +
                                        "] " +
                                        _vm._s(props.item.storeName)
                                    )
                                  ])
                            ]
                          }
                        }
                      ]),
                      model: {
                        value: _vm.adjustStore.storeName,
                        callback: function($$v) {
                          _vm.$set(_vm.adjustStore, "storeName", $$v)
                        },
                        expression: "adjustStore.storeName"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c("div", { staticClass: "form-item" }, [
                _c("div", { staticClass: "form-item-label" }, [
                  _vm._v("行政区域")
                ]),
                _c(
                  "div",
                  { staticClass: "form-item-content" },
                  [
                    _c("cc-select", {
                      staticStyle: { "vertical-align": "middle" },
                      attrs: {
                        options: _vm.adjustStore.districtList,
                        valueKey: "districtId",
                        labelKey: "name"
                      },
                      model: {
                        value: _vm.adjustStore.districtId,
                        callback: function($$v) {
                          _vm.$set(_vm.adjustStore, "districtId", $$v)
                        },
                        expression: "adjustStore.districtId"
                      }
                    })
                  ],
                  1
                )
              ]),
              _c(
                "div",
                { staticClass: "form-item" },
                [
                  _c(
                    "Button",
                    {
                      attrs: { loading: _vm.adjustStore.queryLoading },
                      on: { click: _vm.queryAdjustableStoreList }
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "Button",
                    {
                      staticClass: "am-margin-left-sm",
                      on: { click: _vm.resetAdjustableStore }
                    },
                    [_vm._v("重置")]
                  )
                ],
                1
              )
            ]),
            _c("table", { staticClass: "am-table am-table-bordered" }, [
              _c("thead", [
                _c("tr", [
                  _c("th", { staticClass: "w90" }, [_vm._v("操作")]),
                  _c("th", [_vm._v("门店名称")]),
                  _c("th", { staticClass: "w90" }, [_vm._v("距离(米)")]),
                  _c("th", [_vm._v("行政区域")]),
                  _c("th", [_vm._v("门店电话")]),
                  _c("th", [_vm._v("门店地址")]),
                  _c("th", [_vm._v("营业时间")])
                ])
              ]),
              _c(
                "tbody",
                [
                  _vm._l(_vm.adjustStore.storeList, function(item, index) {
                    return _c("tr", { key: index }, [
                      _c(
                        "td",
                        [
                          _c(
                            "Button",
                            {
                              attrs: { type: "info", loading: item.loading },
                              nativeOn: {
                                click: function($event) {
                                  return _vm.submitAdjustStore(item)
                                }
                              }
                            },
                            [_vm._v("选择")]
                          )
                        ],
                        1
                      ),
                      _c("td", [_vm._v(_vm._s(item.storeName))]),
                      _c("td", [_vm._v(_vm._s(item.distance))]),
                      _c("td", [_vm._v(_vm._s(item.districtName))]),
                      _c(
                        "td",
                        _vm._l(item.phoneNumberList, function(item, index) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item) +
                                "\n            "
                            )
                          ])
                        }),
                        0
                      ),
                      _c("td", [_vm._v(_vm._s(item.storeAddress))]),
                      _c(
                        "td",
                        _vm._l(item.serviceTime, function(item, index) {
                          return _c("div", { key: index }, [
                            _vm._v(
                              "\n              " +
                                _vm._s(item.beginTime) +
                                " - " +
                                _vm._s(item.endTime) +
                                "\n            "
                            )
                          ])
                        }),
                        0
                      )
                    ])
                  }),
                  _vm.adjustStore.storeList.length === 0
                    ? _c("tr", [
                        _c(
                          "td",
                          {
                            staticClass: "am-text-center",
                            attrs: { colspan: "7" }
                          },
                          [_vm._v("查无数据")]
                        )
                      ])
                    : _vm._e()
                ],
                2
              )
            ]),
            _c("div", { staticClass: "paging am-padding-sm" }, [
              _c("div", { staticClass: "paging-contain" }, [
                _c("div", { staticClass: "paging-item" }, [
                  _vm._v(
                    "\n            第" +
                      _vm._s(_vm.adjustStore.pageNow) +
                      "页\n          "
                  )
                ]),
                _c(
                  "div",
                  { staticClass: "paging-item" },
                  [
                    _c(
                      "Button",
                      {
                        attrs: { disabled: _vm.adjustStore.pageNow <= 1 },
                        nativeOn: {
                          click: function($event) {
                            return _vm.changeAdjustStorePaging(
                              _vm.adjustStore.pageNow - 1
                            )
                          }
                        }
                      },
                      [_vm._v("\n              上一页\n            ")]
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "paging-item" },
                  [
                    _c(
                      "Button",
                      {
                        attrs: {
                          disabled:
                            _vm.adjustStore.pageNow >= _vm.adjustStore.pageTotal
                        },
                        nativeOn: {
                          click: function($event) {
                            return _vm.changeAdjustStorePaging(
                              _vm.adjustStore.pageNow + 1
                            )
                          }
                        }
                      },
                      [_vm._v("下一页\n            ")]
                    )
                  ],
                  1
                ),
                _c("div", { staticClass: "paging-item" }, [
                  _vm._v(
                    "\n            共" +
                      _vm._s(_vm.adjustStore.pageTotal) +
                      "页\n          "
                  )
                ])
              ])
            ])
          ]),
          _c(
            "div",
            {
              staticClass: "am-text-right",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "Button",
                {
                  staticClass: "am-btn-cancel",
                  nativeOn: {
                    click: function($event) {
                      _vm.adjustStore.visible = false
                    }
                  }
                },
                [_vm._v("放弃")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-ac0ce134", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ac0ce134","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pagesCache/orderList/orderList.vue
// module id = /bF9
// module chunks = 3